 

// export const baseUrl = 'https://analog-ias.appspot.com/';

// export const baseUrl =  'https://als-athena.appspot.com';
// export const baseUrl = 'https://fivemantra.appspot.com';
// export const baseUrl = 'http://tothepointdemo.appspot.com';
// export const baseUrl = 'http://65.0.134.240';
export const baseUrl = 'https://tothepointdemo.appspot.com';
// export const baseUrl = Config.BASE_URL_TESTING;
// export const baseUrl = Config.BASE_URL_PRODUCTION_PREVIOUS;

// export const baseUrl = Config.BASE_URL_PRODUCTION;



// export const baseUrl = 'https://tothepoint-beta.appspot.com';  //for production

// export const baseUrl = 'https://20200424t155025-dot-tothepoint-beta.appspot.com/' // for production update  version
// export const baseUrl = 'https://20200425t095014-dot-tothepoint-beta.appspot.com' // for production update  version

// export const baseUrl = 'https://testtothepoint.appspot.com';
